import { render, staticRenderFns } from "./ProcessIcon.vue?vue&type=template&id=f22b9bf4&"
import script from "./ProcessIcon.vue?vue&type=script&lang=js&"
export * from "./ProcessIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports